const Signup = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Sign Up</h1>
      <p className="text-lg mb-4">
        Join the Medical Association of Andhra Pradesh.
      </p>
    </div>
  );
};

export default Signup; 